import { useEffect, useState } from 'react';

function CountdownTimer({ targetTime, onExpire }) {
  const [timeLeft, setTimeLeft] = useState(targetTime - Date.now());

  useEffect(() => {
    const initialTimeLeft = targetTime - Date.now();
    setTimeLeft(initialTimeLeft);
    console.log( typeof onExpire )
    if (initialTimeLeft <= 0) {
      console.log("Already expired:", initialTimeLeft);
      if (typeof onExpire === 'function') {
        onExpire?.();
      }
      return; // Skip setting interval
    }
  
    const interval = setInterval(() => {
      const newTimeLeft = targetTime - Date.now();
      setTimeLeft(newTimeLeft);
  
      if (newTimeLeft <= 0) {
        console.log("Time just expired:", newTimeLeft);
        clearInterval(interval);
        onExpire?.();
        if (typeof onExpire === 'function') {
          console.log("Time   expired: function", newTimeLeft);
          onExpire?.();
        }
      }
    }, 1000);
  
    return () => clearInterval(interval);
  }, [targetTime]);

  if (timeLeft <= 0) return <span>Expired</span>;

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return `${h}h ${m}m ${s}s`;
  };

  return <span>{formatTime(timeLeft)}</span>;
}

export default CountdownTimer;
